var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7,13.7h-2.5v-3.4h2.5c0.4,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8h-2.5V6.2c0-0.4-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v2.5 h-3.4V6.2c0-0.4-0.4-0.8-0.8-0.8S8.6,5.8,8.6,6.2v2.5H6.1c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h2.5v3.4H6.1 c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h2.5v2.5c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-2.5h3.4v2.5c0,0.4,0.4,0.8,0.8,0.8 s0.8-0.4,0.8-0.8v-2.5h2.5c0.4,0,0.8-0.4,0.8-0.8S18.1,13.7,17.7,13.7z M10.2,13.7v-3.4h3.4v3.4H10.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.d6b7b9bd9a74c3eb4b538c08e71b4006.svg";
export { ForwardRef as ReactComponent };